import styled from "styled-components";

export const Secao = styled.div`
  margin-bottom: 20px;
`;

export const SecaoTitulo = styled.h6`
  font-weight: 700;
  font-size: 0.95rem;
  color: #1f2937;
  margin-bottom: 8px;
`;

export const Bloco = styled.div`
  background-color: #f9fafb;
  border-radius: 8px;
  padding: 16px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
`;

export const Campo = styled.div`
  display: grid;
  gap: 2px;
`;

export const Label = styled.span`
  font-size: 0.75rem;
  color: #6b7280;
`;

export const Valor = styled.span`
  font-size: 0.9rem;
  color: #111827;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;

  svg {
    cursor: pointer;
    color: #6b7280;
    font-size: 0.8rem;
  }
`;

export const BoletoBloco = styled.div`
  background-color: #f9fafb;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const BaixarTodos = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  align-self: flex-start;
  margin-bottom: 8px;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  font-size: 0.85rem;
  color: #374151;

  &:hover {
    color: #111827;
  }

  svg {
    font-size: 0.8rem;
  }
`;

export const BoletoLista = styled.div`
  max-height: 220px;
  overflow-y: auto;
  display: grid;
  gap: 8px;
`;

export const BoletoCabecalho = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.75rem;
  font-weight: 600;
  color: #6b7280;
`;

export const BoletoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 0.85rem;
`;

export const BoletoNome = styled.span`
  flex: 1;
  min-width: 0;
  background-color: #fff;
  border-radius: 6px;
  padding: 8px 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const BoletoAcoes = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  background-color: #fff;
  border-radius: 6px;
  padding: 8px 12px;
`;

export const BoletoAcaoBotao = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  padding: 4px;
  cursor: pointer;
  color: #111827;

  svg {
    font-size: 0.9rem;
  }
`;

export const ContainerFechar = styled.div`
  display: flex;
  justify-content: flex-end;
`;
